export const errorIdentifier = (err) => {
    debugger;
    if (err?.response?.status === 404) {
        return err.response?.data?.message
    } else if (err?.response?.status === 500) {
        if (err.response?.data?.error?.code === 11000) {
            return `${Object.keys(err.response.data.error.keyPattern)[0]} Already Exists!`
        } else if(err.response?.data?.error?.name === "JsonWebTokenError"){
            return 'Token Expired! Please log in again'
        } 
        else {
            return err.response.data.error.message
        }
    } else if(err?.response?.status === 401) {
        return err.response?.data?.message
    }
    else {
        return 'Something Went Wrongg!'
    }

    // return err.response.data.message?err.response.data.message:'Something Went Wrong!';

}